import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import { useParams } from "react-router";
import {
  useVbsOrderShowQuery,
  useVbsOrderUpdatePostalAddressMutation,
  useVbsOrderUpdateRepresentativeMutation,
  useVbsOrderUpdateServiceAddressMutation,
  useVbsOrderUpdateServiceContactMutation,
} from "@/services/backend/vbs/orders/api/order-api";
import { Card } from "@/shared/components/ui/card";
import t from "@/lang/lang";
import { PostalAddressCardWithMutation } from "@/services/backend/addresses/components/postal-address-card";
import { ServiceAddressCardWithMutation } from "@/services/backend/addresses/components/service-address-card";
import { ContactCardWithMutation } from "@/services/backend/contacts/components/contact-card";
import { RepresentativeCardWithMutation } from "@/services/backend/representatives/components/representative-card";

export function AddressesAndContactsRoute() {
  const { orderId } = useParams();
  const {
    data: order,
    isLoading,
    error,
  } = useVbsOrderShowQuery({
    id: orderId!,
  });

  if (error) {
    return <RTKQueryErrorAlert error={error} />;
  }

  if (isLoading) {
    return (
      <Card className="text-muted-foreground animate-pulse p-6">
        {t("Lade Daten...")}
      </Card>
    );
  }

  return (
    <div className="grid gap-2 xl:grid-cols-2">
      <PostalAddressCardWithMutation
        id={order!.id}
        address={order!.postalAddress}
        mutation={useVbsOrderUpdatePostalAddressMutation}
      />
      <ServiceAddressCardWithMutation
        id={order!.id}
        address={order!.serviceAddress}
        mutation={useVbsOrderUpdateServiceAddressMutation}
      />
      <ContactCardWithMutation
        fieldName="serviceContact"
        id={order!.id}
        contact={order!.serviceContact}
        mutation={useVbsOrderUpdateServiceContactMutation}
      />
      <RepresentativeCardWithMutation
        id={order!.id}
        representative={order!.representative}
        mutation={useVbsOrderUpdateRepresentativeMutation}
      />
    </div>
  );
}
